import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { BookOpen, ArrowRight } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function BlogPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND}/api/blog?publie=true`)
      .then(r => r.json())
      .then(d => setArticles(d.articles || []))
      .catch((err) => { /* eslint-disable-line no-empty */ })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ background: 'var(--bg, #FBF7F1)', minHeight: '100vh' }}>
      <Header />
      <div className="container-ose section-py">
        <h1 className="font-display text-3xl font-bold mb-2" style={{ color: 'var(--text)', letterSpacing: '-0.02em' }}>Blog & Conseils</h1>
        <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>Astuces et conseils pour réussir vos événements dans le Lot</p>
        {loading ? (
          <div className="flex justify-center py-20"><div className="animate-spin w-10 h-10 rounded-full" style={{ border: '2px solid #2A2A2A', borderTopColor: '#D4AF37' }} /></div>
        ) : (
          <div data-testid="blog-list" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {articles.map(a => (
              <Link key={a.id} to={`/blog/${a.slug}`} data-testid="blog-article-card" className="card-premium overflow-hidden block">
                {a.image && <img src={a.image} alt={a.titre} className="w-full h-44 object-cover" loading="lazy" />}
                <div className="p-5">
                  <div className="flex flex-wrap gap-1 mb-2">
                    {a.tags?.map(t => <span key={t} className="px-2 py-0.5 rounded-full text-xs" style={{ background: 'rgba(197,216,249,0.15)', color: '#C5D8F9' }}>{t}</span>)}
                  </div>
                  <h2 className="font-semibold mb-2 text-sm" style={{ color: 'var(--text)', lineHeight: '1.4' }}>{a.titre}</h2>
                  <p className="text-xs mb-3 line-clamp-2" style={{ color: 'var(--text-muted)' }}>{a.extrait}</p>
                  <div className="flex items-center gap-1 text-xs" style={{ color: 'var(--teal)' }}>Lire l'article <ArrowRight size={12} /></div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
